import React from "react"
import AcreditacionTest from "./AcreditacionTest";

const Acreditacion = () => {
    return <AcreditacionTest />
}

export default Acreditacion
